// extracted by mini-css-extract-plugin
export default {"msgM":"_89cdfe34cc"};